<template>
	<div>
		<span v-if="nationalSponsor && useLabel" class="flavor-text">{{
			simulationType.toLowerCase().includes('virtual')
				? $t('sponsoredBy')
				: $t('poweredBy')
		}}</span>

		<img
			v-if="nationalSponsor"
			class="logo"
			:src="nationalSponsor"
			alt="sponsor"
		/>
	</div>
</template>
<script>
import { getStorageData } from '@/helpers/storageFunctions';
export default {
	props: {
		externalSimType: {
			type: String,
			default: ''
		},
		useSecondary: {
			type: Boolean,
			default: false
		},
		useLabel: {
			type: Boolean,
			default: true
		}
	},
	computed: {
		simulationType() {
			if (this.externalSimType) {
				return this.externalSimType;
			}
			return this.$store.getters.simulationType;
		},
		nationalSponsor() {
			if (this.useSecondary) {
				const localSponsors = getStorageData('localSponsors');

				return (localSponsors && localSponsors['SecondaryBillboard']) || null;
			}

			if (this.simulationType) {
				return this.$store.getters.nationalSponsor(this.simulationType);
			}
			return null;
		}
	}
};
</script>
<style lang="scss" scoped>
.flavor-text {
	color: $font-dark;
	font-family: 'RobotoRegular';
	font-size: 12px;

	@media (min-width: $breakpoint-mid) {
		font-size: 14px;
	}
}

.logo {
	display: block;
	max-height: 48px;
	margin-top: 4px;
}
</style>
